export default "__VITE_ASSET__cdeee54b__"